export const API_ENDPOINT = 'https://backoffice.dev.vntana.com';

//export const GOOGLE_MAP_KEY = 'AIzaSyCS2YQkKRYqen_DLeqwHFxmFeZpzXUe6zs';
